import { render, staticRenderFns } from "./VueGitalk.vue?vue&type=template&id=16cb7b8c&"
import script from "./VueGitalk.vue?vue&type=script&lang=ts&"
export * from "./VueGitalk.vue?vue&type=script&lang=ts&"
import style0 from "./VueGitalk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports